import classNames from "classnames";
import { NavLink, useLocation } from "react-router-dom";
import { MouseEventHandler } from "react";
import { makeLangUrl } from "helpers/makeLangUrl";

// Constants
import { PROFILE_NAVIGATION_ENUMS } from "constants/navigation/profile";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useGTM } from "hooks/useGTM";
import { useSupport } from "hooks/useSupport";

// Components
import NotificationCircle from "components/atoms/NotificationCircle";

import "./styles.sass";

type ProfileNavigationLinkProps = {
  id: PROFILE_NAVIGATION_ENUMS;
  name: string;
  icon: JSX.Element;
  url: string;
  hasNotify?: boolean;
  htmlId?: string;
};

const ProfileNavigationLink = (props: ProfileNavigationLinkProps) => {
  const { id, name, icon, url, hasNotify, htmlId } = props;
  const supportInit = useSupport();
  const t = useTranslate();
  const GTM = useGTM();
  const location = useLocation();

  const isActive =
    location.pathname === url ||
    (id === PROFILE_NAVIGATION_ENUMS.TRANSACTIONS &&
      (location.pathname.includes("/profile/transactions/withdrawal") ||
        location.pathname.includes("/profile/transactions/deposit")));

  const profileItemClass = classNames("ProfileNavigationLink", {
    active: isActive,
  });

  const handleMenuClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (id === PROFILE_NAVIGATION_ENUMS.ACCOUNT) {
      GTM.clickProfilePage();
    }
    if (id === PROFILE_NAVIGATION_ENUMS.BONUS) {
      GTM.clickBonusPage();
    }
    if (id === PROFILE_NAVIGATION_ENUMS.TRANSACTIONS) {
      GTM.clickTransactionHistory();
    }
    if (id === PROFILE_NAVIGATION_ENUMS.GAMES_HISTORY) {
      GTM.clickGameHistory();
    }
    if (id === PROFILE_NAVIGATION_ENUMS.SUPPORT) {
      e.preventDefault();
      supportInit();
      GTM.clickSupport();
    }
    if (id === PROFILE_NAVIGATION_ENUMS.INVITE) {
      GTM.clickInviteFriend();
    }
  };

  return (
    <NavLink
      to={makeLangUrl(url)}
      className={profileItemClass}
      onClick={handleMenuClick}
      end
      id={htmlId}
    >
      {icon} <span>{t(name)}</span>
      {hasNotify && (
        <NotificationCircle className="ProfileNavigationLink__notify" />
      )}
    </NavLink>
  );
};

export default ProfileNavigationLink;
